:host {
  display: block;
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
}

.ls-status-messages {
  padding-bottom: 1rem;
}

.ls-status-messages .title {
  font-size: var(--ls-text-2xl);
  line-height: var(--ls-line-2xl);
  font-weight: 600;
}

.ls-status-messages .label {
  font-size: var(--ls-text-xl);
  line-height: var(--ls-line-xl);
  align-self: center;
  grid-column: 1;
  grid-row: 1 / 3;
}

.ls-status-messages .message {
  max-width: 800px;
  min-width: 550px;
  display: grid;
  grid-template-columns: 6fr 3fr 3fr;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--ls-gray-100);
}

.ls-status-messages .message:last-child {
  border-bottom: none;
}

.ls-status-messages .timestamp,
.ls-status-messages .identification {
  font-size: var(--ls-text-sm);
  line-height: var(--ls-line-sm);
  color: var(--ls-gray-600);
}

.ls-status-messages .human-readable-timestamp {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  align-self: end;
}

.ls-status-messages .relative-timestamp {
  grid-column: 3;
}

.ls-status-messages .severity {
  color: var(--ls-default-text);
  background-color: var(--ls-default-background);
  font-size: var(--ls-text-sm);
  line-height: var(--ls-line-sm);
  height: var(--ls-line-sm);
  border-radius: 3px;
  width: fit-content;
  padding: 0.375rem 0.5rem;
  grid-column: 2;
  grid-row: 1 / 3;
  align-self: center;
}

.ls-status-messages .impact {
  color: var(--ls-danger-text);
  background-color: var(--ls-danger-background);
}

.ls-status-messages .non-impact {
  color: var(--ls-warning-text);
  background-color: var(--ls-warning-background);
}

.ls-status-messages .informational {
  color: var(--ls-info-text);
  background-color: var(--ls-info-background);
}
